import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "./ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card";

export function SisaVoucherSettingCard() {
  const [show, setShow] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/sisa-voucher").then((r) => setShow(!!r.data.show_agents)).catch(() => setShow(false)); }, []);
  const toggle = async () => {
    setSaving(true);
    try {
      await api.put("/settings/sisa-voucher", { show_agents: !show });
      setShow(!show); toast.success(!show ? "Sisa kuota/jam kini TAMPIL di halaman agen" : "Sisa kuota/jam DISEMBUNYIKAN dari agen (hanya Super Admin)");
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };
  if (show === null) return null;
  return (
    <Card className="bg-card border-border" data-testid="sisa-voucher-settings">
      <CardHeader className="pb-2">
        <CardTitle className="text-base font-heading flex items-center justify-between gap-2">
          <span className="flex items-center gap-2">{show ? <Eye className="w-4 h-4 text-emerald-500" /> : <EyeOff className="w-4 h-4 text-muted-foreground" />} Sisa Kuota / Jam Voucher</span>
          <span className={`text-[11px] font-mono px-2 py-0.5 rounded-full border ${show ? "bg-emerald-500/15 text-emerald-500 border-emerald-500/30" : "bg-muted text-muted-foreground border-border"}`} data-testid="sisa-voucher-status">{show ? "TAMPIL KE AGEN" : "HANYA SUPER ADMIN"}</span>
        </CardTitle>
        <p className="text-xs text-muted-foreground">Mengatur apakah kolom <b>Sisa</b> (sisa kuota GB, sisa jam, masa berlaku) di Data Voucher, Cek Kode, dan Reset Voucher ditampilkan ke agen & admin lain. Super Admin selalu bisa melihat.</p>
      </CardHeader>
      <CardContent>
        <Button disabled={saving} onClick={toggle} className={show ? "bg-rose-600 hover:bg-rose-700 text-white" : "bg-emerald-600 hover:bg-emerald-700 text-white"} data-testid="sisa-voucher-toggle">{show ? "Sembunyikan dari Agen" : "Tampilkan ke Agen"}</Button>
      </CardContent>
    </Card>
  );
}
